module.exports = __webpack_public_path__ + "img/trx.4f3f3903.svg";